import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { Typography, Button, Icons } from '@hmsexp/component-library';
import { View, TouchableOpacity } from '../Common/react-native-components';
import DownloadIcon from '../../../../common/icons/DownloadIcon/index';
import styles from './styles';
import ConfirmReportPopup from './ConfirmReportPopup';
import { fetchLinkWithAppliedFilters } from '../../containers/Filters/utils/reportActions';
import {
  DOWNLOAD_FILTER_KEYS,
  REPORT_CONFIGS,
  DOWNLOAD_REPORT_BUTTON,
  PROPERTY_PERFORMANCE_REPORT,
  ALERT_REPORT,
  PDF_LABEL,
  EXCEL_LABEL,
} from './downloadConstants'

const DownloadReportButton = ({
  appliedFilters,
  appliedFilterValues,
  dispatch
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [activeSubMenu, setActiveSubMenu] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedReport, setSelectedReport] = useState(null);
  const [email, setEmail] = useState('');
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const target = event.target || event.srcElement;
      if (dropdownRef.current && !dropdownRef.current.contains(target)) {
        setIsDropdownOpen(false);
        setActiveSubMenu(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, []);

  const handleToggleDropdown = () => {
    const next = !isDropdownOpen;
    setIsDropdownOpen(next);
    if (!next) setActiveSubMenu(null);
    window.dispatchEvent(new Event('download-filters-sync'));
  };

  const handleFormatSelect = (reportConfig, reportFormat) => {
    setSelectedReport({ ...reportConfig, report_type: reportFormat });
    setIsModalOpen(true);
    setIsDropdownOpen(false);
    setActiveSubMenu(null);
  };

  const handleConfirmDownload = () => {
    const downloadFilters = {};
    if (appliedFilterValues && Object.keys(appliedFilterValues).length > 0) {
      Object.keys(appliedFilterValues).forEach(key => {
        const normalizedKey = key.toLowerCase();
        if (DOWNLOAD_FILTER_KEYS.includes(normalizedKey)) {
          downloadFilters[key] = appliedFilterValues[key];
        }
      });
    }

    dispatch(fetchLinkWithAppliedFilters(
      downloadFilters,
      selectedReport?.api_report_type,
      selectedReport?.report_type,
      email
    ));

    setIsModalOpen(false);
    setEmail('');
  };

  return (
    <View ref={dropdownRef} style={styles.downloadButtonWrapper}>
      <Button
        size='medium'
        title={DOWNLOAD_REPORT_BUTTON}
        onClick={handleToggleDropdown}
        icon={DownloadIcon ? <DownloadIcon width="14" height="14" stroke="white" /> : null}
        style={styles.signOutButton}
      />

      {isDropdownOpen && (
        <View style={styles.dropdownMenu}>
          <View style={[styles.subMenuWrapper, { zIndex: activeSubMenu === PROPERTY_PERFORMANCE_REPORT ? 10 : 1 }]}>
            <TouchableOpacity
              style={styles.dropdownItem}
              onPress={() => setActiveSubMenu(activeSubMenu === PROPERTY_PERFORMANCE_REPORT ? null : PROPERTY_PERFORMANCE_REPORT)}
            >
              <Typography variant="subtitle2">{PROPERTY_PERFORMANCE_REPORT}</Typography>
              {Icons.ChevronRight && <Icons.ChevronRight size="small" />}
            </TouchableOpacity>
            {activeSubMenu === PROPERTY_PERFORMANCE_REPORT && (
              <View style={styles.subDropdownMenu}>
                <TouchableOpacity
                  style={styles.dropdownItem}
                  onPress={() => handleFormatSelect(REPORT_CONFIGS.PROPERTY_PERFORMANCE_REPORT, 'PDF')}
                >
                  <Typography variant="subtitle2">{PDF_LABEL}</Typography>
                </TouchableOpacity>
                <TouchableOpacity
                  style={styles.dropdownItem}
                  onPress={() => handleFormatSelect(REPORT_CONFIGS.PROPERTY_PERFORMANCE_REPORT, 'EXCEL')}
                >
                  <Typography variant="subtitle2">{EXCEL_LABEL}</Typography>
                </TouchableOpacity>
              </View>
            )}
          </View>

          <View style={[styles.subMenuWrapper, { zIndex: activeSubMenu === ALERT_REPORT ? 10 : 1 }]}>
            <TouchableOpacity
              style={styles.dropdownItem}
              onPress={() => setActiveSubMenu(activeSubMenu === ALERT_REPORT ? null : ALERT_REPORT)}
            >
              <Typography variant="subtitle2">{ALERT_REPORT}</Typography>
              {Icons.ChevronRight && <Icons.ChevronRight size="small" />}
            </TouchableOpacity>
            {activeSubMenu === ALERT_REPORT && (
              <View style={styles.subDropdownMenu}>
                <TouchableOpacity
                  style={styles.dropdownItem}
                  onPress={() => handleFormatSelect(REPORT_CONFIGS.ALERT_REPORT, 'PDF')}
                >
                  <Typography variant="subtitle2">{PDF_LABEL}</Typography>
                </TouchableOpacity>
                <TouchableOpacity
                  style={styles.dropdownItem}
                  onPress={() => handleFormatSelect(REPORT_CONFIGS.ALERT_REPORT, 'EXCEL')}
                >
                  <Typography variant="subtitle2">{EXCEL_LABEL}</Typography>
                </TouchableOpacity>
              </View>
            )}
          </View>
        </View>
      )}

      <ConfirmReportPopup
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
          setEmail('');
        }}
        onConfirm={handleConfirmDownload}
        selectedReport={selectedReport}
        appliedFilters={appliedFilterValues}
        email={email}
        setEmail={setEmail}
      />
    </View>
  );
};

const mapStateToProps = state => ({
  appliedFilters: state.filterReducer?.applied_filters,
  appliedFilterValues: state.filterReducer?.applied_filter_values
});

export default connect(mapStateToProps)(DownloadReportButton);